module.exports = __webpack_public_path__ + "static/img/5743_phase_function_Paper_PointsHejduk_Prediction.2dc03fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5743_phase_function_Paper_PointsHejduk_Prediction.png
// module id = dQH+
// module chunks = 0